import React from 'react';
import { situacoesProblemas, situacoesSolucoes, siteConfig } from '../../data/mock';
import { MessageCircle, ArrowRight } from 'lucide-react';

const SituacoesSection = () => {
  const whatsappLink = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(siteConfig.whatsappMessage)}`;

  return (
    <section className="pt-4 pb-24 bg-[#24293f]">
      <div className="max-w-7xl mx-auto px-6">


        {/* Center Container */}
        <div className="flex justify-center">
          {/* Problems Card - Red */}
          <div className="w-full max-w-2xl group relative bg-[#451a1a] rounded-2xl overflow-hidden border border-red-900/50 hover:border-red-500/50 transition-colors duration-300">
            {/* Header */}
            <div className="bg-red-900/30 p-8 border-b border-red-900/30">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 border-2 border-red-500/50 rounded-lg flex items-center justify-center bg-red-900/40">
                  <svg className="w-6 h-6 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-white text-center w-full">
                  Sua empresa está passando por alguma<br />dessas situações?
                </h3>
              </div>
            </div>

            <div className="p-8">
              <ul className="space-y-4">
                {situacoesProblemas.map((item, index) => (
                  <li
                    key={index}
                    className="flex items-start gap-3 text-neutral-300 group-hover:text-white transition-colors"
                  >
                    <div className="mt-1 w-5 h-5 rounded-full bg-red-900/50 border border-red-500/30 flex items-center justify-center flex-shrink-0">
                      <svg className="w-3 h-3 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 6l12 12M6 18L18 6" />
                      </svg>
                    </div>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-neutral-400 mb-6 text-lg">
            Essa conversa pode te economizar tempo e dinheiro.
          </p>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center justify-center gap-3 bg-[#32D74B] hover:bg-[#28b03d] text-white px-8 py-4 rounded-lg font-bold text-lg uppercase tracking-wide transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-green-500/25"
          >
            <MessageCircle className="w-5 h-5" />
            {siteConfig.ctaText}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default SituacoesSection;
